import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "app/api";

export interface SignUpPuOssRequest {
    REGISTER: {
        emailAddr: string;
        nama: string;
        role: string;
        password: string;
    }
}

export interface SignUpPuOssResponse {
    REGISTER: {
        status: number;
        data: {
            userid: string;
            nama: string;
            email_addr: string;
            role: string;
            unik_id: string;
        }
        token: string;
    }
}


export const signUpPuOss = createAsyncThunk(
    "signUpPuOss",
    async (data: SignUpPuOssRequest, thunkAPI) => {
        const config = {
            method: "post",
            url: "auth/sign-up-oss",
            data: data,
        };

        return api(config).then(
            (res: any) => {
                return res.data;
            },
            (err: any) => {
                return thunkAPI.rejectWithValue(err.response.data.REGISTER.data);
            }
        );
    }
);

const PuAuthSlice = createSlice({
    name: "PuAuthSlice",
    initialState: {
        dataUserPu: {} as SignUpPuOssResponse,
        isFetching: false,
        isSuccessSignUpPuOss: false,
        isError: false,
        errorMessage: "" as string,
    },
    reducers: {
        clearState: (state, action) => {
            state.isFetching = false;
            state.isSuccessSignUpPuOss = false;
            state.isError = false;
            state.errorMessage = "";
        },
    },
    extraReducers: (builder) => {
        // signUpPuOss
        builder.addCase(signUpPuOss.fulfilled, (state, { payload }) => {
            state.isFetching = false;
            state.dataUserPu = payload;
            state.isSuccessSignUpPuOss = true;
            return state;
        });
        builder.addCase(signUpPuOss.rejected, (state, payload: any) => {
            state.isFetching = false;
            state.isError = true;
            state.errorMessage = payload.payload;
        });
        builder.addCase(signUpPuOss.pending, (state, action) => {
            state.isFetching = true;
        });
    },
});

export const { clearState } = PuAuthSlice.actions;
export default PuAuthSlice.reducer;
